// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___qOjl","label":"styles_label__19qU_"};